// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-wrap[data-v-20d4f59b]{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);min-width:350px;max-width:450px;padding:2em;border:1px solid #eee;box-shadow:0 0 10px rgba(0,0,0,.3)}.error-wrap .error-content .error-title[data-v-20d4f59b]{font-size:1.2em;font-weight:700}", ""]);
// Exports
module.exports = exports;
